/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2021 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
export const isReadAloudEnabled = stores => stores.readAloudStore.isReadAloudEnabled;
export const isReadAloudReady = stores => stores.readAloudStore.isReadAloudReady;

export const isFirstNode = stores => {
  const pageIndex = getPageIndex(stores),
    nodeIndex = getNodeIndex(stores),
    pagesText = getPagesText(stores);
  if (pageIndex === undefined) return true;
  if (nodeIndex > 0) return false; // Not the first node in page
  for (let i = pageIndex - 1; i >= 0; i--) if (pagesText[i] && pagesText[i].length) return false; // Previous pages have nodes
  return true;
};

export const isLastNode = stores => {
  const pageIndex = getPageIndex(stores),
    nodeIndex = getNodeIndex(stores),
    pagesText = getPagesText(stores);
  if (pageIndex === undefined) return true;
  const pageText = pagesText[pageIndex] || [];
  if (nodeIndex < pageText.length - 1) return false; // Nodes left in page
  for (let i = pageIndex + 1; i < pagesText.length; i++) if (pagesText[i] && pagesText[i].length) return false; // Subsequent pages have nodes
  return true;
};

export const isReadAloudActive = stores => stores.readAloudStore.isReadAloudActive;
export const isReadAloudPaused = stores => stores.readAloudStore.isPaused;
export const isNextButtonDisabled = stores => isLastNode(stores) || isReadAloudPausedByButton(stores);
export const isPrevButtonDisabled = stores => isFirstNode(stores) || isReadAloudPausedByButton(stores);
export const isReadAloudPausedByButton = stores => stores.readAloudStore.isPausedByButton;
export const getPagesText = stores => stores.readAloudStore.pagesText;
export const getPageIndex = stores => stores.readAloudStore.pageIndex;
export const getNodeIndex = stores => stores.readAloudStore.nodeIndex;
export const getWordPosition = stores => stores.readAloudStore.wordPosition;
export const getVoiceList = stores => stores.readAloudStore.voiceList;
export const getSelectedVoiceIndex = stores => stores.readAloudStore.selectedVoiceIndex;
export const getVoiceRateList = stores => stores.readAloudStore.voiceRateList;
export const getSelectedRateIndex = stores => stores.readAloudStore.selectedRateIndex;
export const getCurrentNode = stores => {
  const pagesText = getPagesText(stores),
    pageIndex = getPageIndex(stores),
    nodeIndex = getNodeIndex(stores);
  return pagesText && pagesText[pageIndex] && pagesText[pageIndex][nodeIndex];
};
export const getCurrentWordRect = stores => stores.readAloudStore.currentWordRect;
export const getCurrentNodeRect = stores => getCurrentNode(stores) && getCurrentNode(stores).contentRect;
export const getIsScrolling = stores => stores.readAloudStore.isScrolling;
